import api from '../service/api.service';

export interface VersionInfo {
  version: string;
  environment: string;
}

export interface ChangelogEntry {
  version: string;
  date: string;
  type: 'major' | 'minor' | 'patch';
  commit: string;
  changes: string[];
}

export const getVersion = async (): Promise<VersionInfo> => {
  const { data } = await api.get<VersionInfo>('v1/versions/api');
  return data;
};

export const getChangelog = async (): Promise<ChangelogEntry[]> => {
  const { data } = await api.get<ChangelogEntry[]>('v1/versions/changelog');
  return data;
};

export const getFullChangelog = async (): Promise<ChangelogEntry[]> => {
  const { data } = await api.get<ChangelogEntry[]>('v1/versions/changelog/full');
  return data;
};
